import styled from 'styled-components';

export const ThreeColumnGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;

  @media ${({ theme }) => theme.queries.minDesktop} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 24px 16px;
  }

  @media ${({ theme }) => theme.queries.minLargeDesktop} {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;

export const TwoColumnGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px 12px;

  @media ${({ theme }) => theme.queries.minDesktop} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 24px 16px;
  }
`;

export const Container = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media ${({ theme }) => theme.queries.minDesktop} {
    gap: 48px;
  }
`;

export const Icon = styled.i`
  display: inline-block;
  width: 36px;
  height: 36px;
  color: ${({ theme }) => theme.colors.neutral.primaryNavy};
  margin-right: 8px;
  text-align: center;
  line-height: 36px;
`;

export const CreditCardIconContainer = styled.i`
  display: inline-block;
  width: 36px;
  height: 36px;
  font-size: 32px;
  color: ${({ theme }) => theme.colors.neutral.primaryNavy};
`;

export const ModalContent = styled.div`
  width: 100%;

  @media ${({ theme }) => theme.queries.minTablet} {
    width: 480px;
  }

  @media ${({ theme }) => theme.queries.minDesktop} {
    width: 600px;
  }
`;

export const PaymentSection = styled.div`
  padding: 16px 0;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: row;
  margin-top: 8px;
  justify-content: flex-end;
`;
